import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconDoubleBed: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 12.8V6c0-1.7-1.3-3-3-3H6C4.3 3 3 4.3 3 6v6.8c-.6.5-1 1.3-1 2.2v6c0 .6.4 1 1 1s1-.4 1-1v-1h16v1c0 .6.4 1 1 1s1-.4 1-1v-6c0-.9-.4-1.7-1-2.2zM5 6c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v6h-1V8c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v4H5V6zm3 6V9h3v3H8zm5-3h3v3h-3V9zm-9 9v-3c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v3H4z',
    })
  )
}
